export enum BalooSyncLogCategoryType {
    Added,
    Updated,
    Reactivated,
    Deactivated,
    AddedToGroup,
    RemovedFromGroup,
    Failed,
}
